import React, { useState } from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, Button } from '@mui/material';

export const PopupAddHomework = ({
  addHomeworkToContent,
  arrObjAtributs,
  closeHomework,
  nameContent,
  firstContent,
  secondContent,
}) => {
  const { t } = useTranslation();

  const [selectedHomework, setSelectedHomework] = useState(null);

  const handleSelectChange = event => {
    setSelectedHomework(event.target.value);
  };

  const handleAddButtonClick = () => {
    if (selectedHomework) {
      addHomeworkToContent(selectedHomework);
    }
  };

  const closePopup = () => {
    closeHomework();
  };

  return (
    <>
      <div className="popup-homework" id="popup-homework-id">
        <div className="popup-homework-content">
          <button className="btn btn-icon close-btn" onClick={e => closePopup()}>
            <span className="icon icon-plus"></span>
          </button>

          <div className="wrap-content">
            {arrObjAtributs && (
              <>
                <h2>{t('Choose which homework')}</h2>

                <Select value={selectedHomework} onChange={handleSelectChange} renderValue={selected => selected?.name}>
                  {arrObjAtributs.map((obj, index) => (
                    <MenuItem key={index} value={obj}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>

                {nameContent === 'first' && firstContent.includes('data-homework-name') && (
                  <h3 className="has-homework-in-list">{t('hasHomeworkInList')}</h3>
                )}

                {nameContent === 'second' && secondContent.includes('data-homework-name') && (
                  <h3 className="has-homework-in-list">{t('hasHomeworkInList')}</h3>
                )}

                {nameContent === 'second' && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddButtonClick}
                    disabled={secondContent.includes('data-homework-name') || !selectedHomework}
                  >
                    {t('addHomeworkObjNotebook')}
                  </Button>
                )}

                {nameContent === 'first' && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddButtonClick}
                    disabled={firstContent.includes('data-homework-name') || !selectedHomework}
                  >
                    {t('addHomeworkObjNotebook')}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
